const methods = {
  format: (assessor, funcaoItem) => {
    if (assessor === true) {
      return 'Sim'
    } else if (assessor === false) {
      if (funcaoItem === 1) {
        return '-'
      } else {
        return 'Não'
      }
    } else {
      return 'Inválido'
    }
  }
}

export default methods



// WEBPACK FOOTER //
// ./src/utils/assessor.js